import React from 'react';
import { Layout, Row, Col, Typography, Space } from 'antd';
import { FacebookOutlined, TwitterOutlined, InstagramOutlined, LinkedinOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './Footer.css';

const { Footer: AntFooter } = Layout;
const { Title, Text } = Typography;

const Footer: React.FC = () => {
  return (
    <AntFooter className="footer">
      <div className="footer-content">
        <Row gutter={[24, 24]}>
          <Col xs={24} sm={12} md={6}>
            <div className="footer-section">
              <Title level={4}>Byondcore</Title>
              <Text>
                Byondcore is a complete accounts and finance admin dashboard for your business.
              </Text>
            </div>
          </Col>
          
          <Col xs={24} sm={12} md={6}>
            <div className="footer-section">
              <Title level={5}>Features</Title>
              <ul>
                <li><Link to="/features">Free Trial</Link></li>
                <li><Link to="/features">Invoice Templates</Link></li>
                <li><Link to="/features">Policy</Link></li>
                <li><Link to="/features">Careers</Link></li>
              </ul>
            </div>
          </Col>
          
          <Col xs={24} sm={12} md={6}>
            <div className="footer-section">
              <Title level={5}>Resources</Title>
              <ul>
                <li><Link to="/support">Support Center</Link></li>
                <li><Link to="/docs">Documentation</Link></li>
                <li><Link to="/community">Community</Link></li>
                <li><Link to="/faq">FAQ</Link></li>
              </ul>
            </div>
          </Col>
          
          <Col xs={24} sm={12} md={6}>
            <div className="footer-section">
              <Title level={5}>Company</Title>
              <ul>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/news">Latest News</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
                <li><Link to="/resources">Resources</Link></li>
              </ul>
            </div>
          </Col>
        </Row>
        
        <div className="footer-bottom">
          <Row justify="space-between" align="middle">
            <Col>
              <Text>Copyright © Byondcore. All Rights Reserved</Text>
            </Col>
            <Col>
              <Space>
                <Link to="/terms">Terms & Conditions</Link>
                <Link to="/privacy">Privacy Policy</Link>
              </Space>
            </Col>
            <Col>
              <Space>
                <Link to="#"><FacebookOutlined /></Link>
                <Link to="#"><TwitterOutlined /></Link>
                <Link to="#"><InstagramOutlined /></Link>
                <Link to="#"><LinkedinOutlined /></Link>
              </Space>
            </Col>
          </Row>
        </div>
      </div>
    </AntFooter>
  );
};

export default Footer; 